import { render, staticRenderFns } from "./sidentify.vue?vue&type=template&id=1d2abc22&scoped=true"
import script from "./sidentify.vue?vue&type=script&lang=js"
export * from "./sidentify.vue?vue&type=script&lang=js"
import style0 from "./sidentify.vue?vue&type=style&index=0&id=1d2abc22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2abc22",
  null
  
)

export default component.exports